import type { Agenda } from '../../types';

export const agenda: Agenda = [
  {
    date: 'Monday, November 3',
    items: [
      {
        id: 'day1-welcome',
        time: '5:00 PM - 7:00 PM',
        title: 'Welcome Reception',
        description:
          "Check in and network with fellow attendees. Cocktails and heavy hors d'oeuvres will be served.",
        locationId: 'grove',
        type: 'reception',
      },
    ],
  },
  {
    date: 'Tuesday, November 4',
    items: [
      {
        id: 'day2-breakfast',
        time: '8:00 AM - 8:30 AM',
        title: 'Breakfast',
        locationId: 'ballroom',
        type: 'meal',
        description: '',
      },
      {
        id: 'day2-introduction',
        time: '8:30 AM - 9:30 AM',
        title: 'A Year in Review: Portfolio and Team Progress',
        description:
          'Mike and Seth will discuss updates to Two Bear Capital, our portfolio and our team since our last gathering.',
        speakerIds: ['mg', 'ss'],
        locationId: 'ballroom',
        type: 'presentation',
      },
      {
        id: 'day2-investment',
        time: '9:30 AM - 10:15 AM',
        title: 'Why Now: Investment Themes and Opportunity Landscape',
        description:
          "John Sullivan will lead a panel discussion outlining Two Bear Capital's investment process and focus areas.",
        speakerIds: ['js', 'ja', 'as', 'ef'],
        locationId: 'ballroom',
        type: 'panel',
      },
      {
        id: 'day2-ai',
        time: '10:15 AM - 11:00 AM',
        title: 'Harnessing AI: Driving our Firm, Portfolio and Investments',
        description:
          'Tim will lead a panel discussion on the future of AI and how it can drive our firm, portfolio and investments.',
        speakerIds: ['tv', 'mg', 'ma', 'jr'],
        locationId: 'ballroom',
        type: 'panel',
      },
      {
        id: 'day2-break-1',
        time: '11:00 AM - 11:15 AM',
        title: 'Morning Break',
        description: '',
        locationId: 'ballroom',
        type: 'break',
      },
      {
        id: 'day2-quantum',
        time: '11:15 AM - 12:00 PM',
        title: 'Post Quantum Agility: the Next Frontier in Cybersecurity',
        description:
          'Tim will lead a panel discussion on the future of quantum computing and the impact it has on cybersecurity.',
        speakerIds: ['tv', 'rk', 'cn'],
        locationId: 'ballroom',
        type: 'panel',
      },
      {
        id: 'day2-lunch',
        time: '12:00 PM - 1:15 PM',
        title: 'Lunch',
        description: '',
        locationId: 'grove',
        type: 'meal',
      },
      {
        id: 'day2-platform',
        time: '1:15 PM - 2:00 PM',
        title:
          'The Two Bear Platform: Adding Business Value to Drive Outsized Returns',
        description:
          'Seth, Kristen, Jeff and Mark will share insights on the evolution of Two Bear’s team structure toward a platform model and how this transformation has enhanced alignment and created integrated value across our team and portfolio.',
        speakerIds: ['ss', 'kg', 'jm', 'ma'],
        locationId: 'ballroom',
        type: 'presentation',
      },
      {
        id: 'day2-biotech',
        time: '2:00 PM - 2:45 PM',
        title: 'Uncertainty and Opportunity: Navigating Biotech in 2025',
        description:
          'While the biotech investing environment continues to face uncertainty, Two Bear’s consistent, long-term approach endures. The team will outline how our “all-weather” philosophy has positioned us to drive sustainable value, regardless of market cycles.',
        speakerIds: ['mg', 'nw', 'as', 'ac'],
        locationId: 'ballroom',
        type: 'presentation',
      },
      {
        id: 'day2-break-2',
        time: '2:45 PM - 3:00 PM',
        title: 'Afternoon Break',
        description: '',
        locationId: 'ballroom',
        type: 'break',
      },
      {
        id: 'day2-sanavia',
        time: '3:00 PM - 3:30 PM',
        title: 'Sanavia Oncology: Strategic Update and Growth Outlook',
        description:
          'Join us for a video presentation where Server Ertem and Mike highlight Sanavia’s mission to transform oncology by uniting rigorous scientific exploration of drug resistance with computational modeling and AI technologies to expedite the discovery of novel therapeutic targets.',
        speakerIds: ['mg', 'se'],
        locationId: 'ballroom',
        type: 'video',
      },
      {
        id: 'day2-cose',
        time: '3:30 PM - 4:30 PM',
        title: 'Looking Ahead: Portfolio Company Performance and Outlook',
        description:
          'To close the day, Mike will provide a comprehensive overview of portfolio company performance and share insights into the firm’s strategic direction and future growth.',
        speakerIds: ['mg'],
        locationId: 'ballroom',
        type: 'presentation',
      },
      {
        id: 'day2-dinner',
        time: '6:00 PM - 9:00 PM',
        title: 'Dinner',
        description:
          'We’ll close the day with a dinner where attendees can unwind, share insights, and enjoy time together outside of the formal sessions.  Please see the Logistics page for additional details.',
        locationId: 'dinner',
        type: 'meal',
      },
    ],
  },
];
